export default __webpack_public_path__ + "static/media/list.30f122f4.svg";